
export default function Profile() {
    return (
        <div id="content">
            <h1>Diego Miranda</h1>
            <h2>Data Scientist / ML Engineer</h2>
            <hr />
            <br />
            <h2>Personal Statement</h2>
            <p>
                I am a Data Scientist / ML Engineer specializing in Retrieval-Augmented Generation (RAG) solutions, utilizing Gemini and Llama (Ollama) large language models to enhance information retrieval and processing. I develop interactive agents and multi-agent chat systems that boost user engagement and support. By leveraging Langchain and N8N, I create seamless workflows for deploying AI-driven solutions. I collaborate with cross-functional teams to identify data-driven opportunities that align with business goals and conduct performance evaluations to improve AI model accuracy and responsiveness. My technical skills include Python, statistical data analysis, and expertise in LLMs, positioning me as a valuable asset in any data-driven environment.
            </p>

            <h2>Work Experience</h2>
            <h3>Data Scientist / ML Engineer</h3>
            <h4>Goiás State Government &mdash; Jan 2024 - Present</h4>
            <ul>
                <li>
                    Architected RAG (Retrieval-Augmented Generation) solutions utilizing Gemini and Llama (Ollama) LLMs and proprietary company data to enhance information retrieval and processing capabilities.
                </li>
                <li>
                    Developed interactive agents and multi-agent chat systems that effectively respond to inquiries across various subjects, improving user engagement and support.
                </li>
                <li>
                    Leveraged Langchain and N8N to create seamless workflows and integrations, optimizing the deployment of AI-driven solutions within the organization.
                </li>
                <li>
                    Collaborated with cross-functional teams to identify data-driven opportunities, ensuring alignment between technical solutions and business objectives.
                </li>
                <li>
                    Conducted performance evaluations and iterative improvements on AI models, enhancing accuracy and responsiveness based on user feedback and data analysis.
                </li>
            </ul>
            <h3>Data Analyst</h3>
            <h4>Goiás State Government &mdash; Nov 2019 - Dec 2023</h4>
            <ul>
                <li>
                    Data transformation, cleaning and analysis to identify possible tax evasion frauds.
                </li>
                <li>
                    Support to revenue auditors with data driven decisions.
                </li>
                <li>
                    Creating reports and presentations with insights for our stakeholders.
                </li>
                <li>
                    Use of tools like Python, Power BI, MongoDB, PostgreSQL, 
                    MS Excel/VBA, MS Access, and SAP BusinessObjects.
                </li>
            </ul>
            <h3>System Analyst</h3>
            <h4>Goiás State Government &mdash; Nov 2010 - Oct 2019</h4>
            <ul>
                <li>
                    Lead engineer of the new Assets Control System. Tech stack NodeJS, React, JavaScript and PostgreSQL.
                </li>
                <li>
                    Lead engineer of a new Workflow System. Tech stack JavaScript, Java, Spring, JPA, Postgress and MySQL.
                </li>
                <li>
                    Team leader on the support and maintenance of legacy systems.
                </li>
            </ul>

            <h2>Education and Certifications</h2>

            <h3>MBA Data Science and Analytics</h3>
            <h4>USP/Esalq &mdash; University of São Paulo &mdash; Sep 2021 - Jul 2023</h4>
            <p>
                A professional Master's degree, with a major in Machine Learning. Conducted a project 
                to train a Convolutional Neural Network to identify and classify cancerous breast 
                lesions on mammographic images.
            </p>

            <h3>Bachelor's degree in Computer Information Systems</h3>
            <h4>UNIALFA &mdash; Alves Faria University &mdash; Jan 2003 - Jul 2007</h4>
            <p>
                A Bachelor's degree, with a major in Information System Engineering. Conducted a project on a new 
                method to store and index fingerprint data for faster search and comparison.
            </p>

            <h3>Business Intelligence Professional Certificate</h3>
            <h4>
                Google Career Certificates &mdash; Aug 2023 &nbsp;
                <a href="https://www.coursera.org/account/accomplishments/professional-cert/Q89PF3FYNZ7A" target="certificate">Show Certificate</a>
            </h4>
            <p />

            <h3>Data Analytics Professional Certificate</h3>
            <h4>
                Google Career Certificates &mdash; Aug 2023 &nbsp;
                <a href="https://www.coursera.org/account/accomplishments/professional-cert/A5AH5DFBYBLJ" target="certificate">Show Certificate</a>
            </h4>
            <p />

            <h2>Recent Side Projects</h2>
            <h3>COVID Pandemic Response</h3>
            <h4>Goianésia City Government &mdash; Feb 2021 - Oct 2021</h4>
            <p>
                In association with "Central COVID" response team from Goianésia Municipal Health Department, 
                we developed a system to collect, treat, store, process and monitor data from population, 
                related to the COVID pandemic testing and symptoms. They use this data to generate daily 
                bulletins about number of infected, cured and deceased. We used Power BI, Python, Excel/VBA 
                and CSV files to this project.
            </p>
        </div>
    )
}